import * as React from 'react';
import { ConstructionIcon } from 'components/NewDashboard/icons/ConstructionIcon';
import { fetchConnectionsWithNoServicesCount } from 'actions/connections';
import { selectIsChasContractor } from '@pec/aion-ui-core/selectors/organization';
import { ToDoDescriptor } from '../types';
import { useAppDispatch, useTypedSelector } from '../../../../combineReducers';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type RouteParams = {
  organizationId: string;
};

export const useReviewClientServicesToDo = (): ToDoDescriptor[] => {
  const dispatch = useAppDispatch();
  const { organizationId } = useParams<RouteParams>();
  const { t } = useTranslation('subscriber');
  const isChas = useTypedSelector(selectIsChasContractor);
  const { connectionsWithNoServicesCount, isFetchingConnectionsWithNoServicesCount } = useTypedSelector(
    state => state.connections
  );

  React.useEffect(() => {
    if (organizationId && !isChas) {
      dispatch(fetchConnectionsWithNoServicesCount(organizationId));
    }
  }, [organizationId, isChas, dispatch]);

  const count = connectionsWithNoServicesCount ?? 0;

  return [
    {
      id: 'reviewClientServices',
      variant: 'link',
      label: t('newDashboard.toDoWidget.reviewClientServices', 'Review client services ({{count}})', { count }),
      icon: <ConstructionIcon />,
      href: `/organizations/${organizationId}/my-connections`,
      isVisible: !isChas && count > 0,
      isFetching: isFetchingConnectionsWithNoServicesCount
    }
  ];
};
